<template>
<div class="SignRollList">
    <div class="search_handle_box">
        <div class="left_box">
            <el-button type="primary" @click="batchDelBtn">批量删除</el-button>
            <el-button v-if="eventInfo.isverifylist === 1" type="primary" @click="openImportPop">导入EXCEL</el-button>
            <el-button @click="exportRollBtn">导出EXCEL</el-button>
        </div>
        <div class="right_box">
            <div style="width: 108px;">
                <el-select @focus="closeDetalisInfo" v-model="searchParams.signtype" placeholder="全部状态">
                    <el-option v-for="item in signTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div class="sign_time_box">
                <el-date-picker @focus="closeDetalisInfo" v-model="searchParams.times" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
            <div style="width: 150px;">
                <el-input @focus="closeDetalisInfo" v-model="searchParams.signName" placeholder="签到人"></el-input>
            </div>
            <el-button @click="handleQuery" type="primary" plain>搜索</el-button>
        </div>
    </div>
     <div class="table_box">
        <el-table @cell-click="tableRowClick" :data="tableData" @selection-change="handleSelectionChange" style="width: 100%">
            <el-table-column type="selection" width="45" align="center"></el-table-column>
            <el-table-column prop="index" label="序号" width="55" align="center"></el-table-column>
            <el-table-column label="最后签到人" align="center">
                <template slot-scope="scope">
                    <div class="user_info_box">
                        <img :src="scope.row.logourl" alt="">
                        <span>{{scope.row.customername}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="signtime" label="最后签到时间" align="center" min-width="160"></el-table-column>
            <el-table-column label="签到状态" align="center">
                <template slot-scope="scope">
                    <span :class="statusTextClass(scope.row.statustext)">{{scope.row.statustext}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="signcount" label="签到次数" align="center"></el-table-column>
            <el-table-column v-if="checkcolname !== ''" prop="checkcolvalue" :label="checkcolname" align="center"></el-table-column>
            <el-table-column label="操作" align="right">
                <template slot-scope="scope">
                    <span @click="tableRowClick(scope.row, testInfo)" style="color: #439FFE;cursor: pointer;">详情</span>
                    <span v-if="eventInfo.isverifylist === 1 && scope.row.status === 0" style="color: #439FFE;"> &nbsp;|&nbsp; </span>
                    <span v-if="eventInfo.isverifylist === 1 && scope.row.status === 0" @click="delRollRowList(scope.row)" style="color: #439FFE;cursor: pointer;">删除</span>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" ref="page" @getList="searchBtn"></page>
    </div>
    <div class="right_details_box bgc box-shadow" :class="showRollDetail ? 'show_helps_box' : 'hide_icon_box'" ref="helps">
        <div v-if="showRollDetail" class="show_helps show_icon" @click="showRollDetail = false"></div>
        <div class="title_box">
            <span>详情资料</span>
            <img @click="showRollDetail = false" :src="require('@/common/images/activeOperate/close_icon.png')" alt="">
        </div>
        <div class="details_info_box">
            <div class="box1">
                <img :src="listDetailsInfo.logourl === '' ? require('@/common/images/other/user.png') : listDetailsInfo.logourl" alt="">
                <div>
                    <p>{{listDetailsInfo.customername}}</p>
                    <p>签到状态：<span :class="statusTextClass(listDetailsInfo.statustext)">{{listDetailsInfo.statustext}}</span></p>
                    <p v-if="listDetailsInfo.status === 30">签到次数：{{listDetailsInfo.signtype}}</p>
                    <p v-if="listDetailsInfo.status === 30">最后签到时间：{{listDetailsInfo.signtime}}</p>
                </div>
            </div>
            <div class="box2">
                <p>详细信息</p>
                <p v-if="eventInfo.isverifylist === 1 && eventInfo.signtype === 2"><span>票号</span><span>{{listDetailsInfo.eticketno}}</span></p>
                <p v-for="(item, index) in listDetailsInfo.objlist" :key="index"><span>{{item.colname}}</span><span>{{item.colvalue}}</span></p>
                <div v-if="listDetailsInfo.objlist.length === 0 && !(eventInfo.isverifylist === 1 && eventInfo.signtype === 2)" class="no_info_box">
                    <img :src="require('@/common/images/other/noinfo.png')" alt="">
                    <span>当前暂无详细信息</span>
                </div>
            </div>
        </div>
    </div>
    <div class="import_tips_box">
        <el-dialog title="导入名单" :visible.sync="importDialog" width="526px" :before-close="handleImportDialogClose" class="improt-dialog">
            <div class="btnlist">
                <el-upload class="upload-excel" :file-list="fileList" :on-exceed="handleExceed" :before-remove="beforeRemove" action="" :auto-upload="false" :on-change="handleImport" ref="upload">
                    <el-button type="primary">点击上传EXCEL文件</el-button>
                </el-upload>
                <el-button @click="downTemplaet" type="text">下载Excel模板</el-button>
            </div>
            <p>上传须知</p>
            <p>1. 上传文件必须为下载的Excel模板文件，每次上传限制在1000条以内；</p>
            <p>2. 请严格按照模板填写，不能在表格外区域增加任何字符；</p>
            <p>3. 每次最多选择一个文件；</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleImportDialogClose">取 消</el-button>
                <el-button type="primary" @click="suerImport">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</div>
</template>

<script>
import {getSignEventImportList, getSignEventImportRollDetail, getSignEventBasicInfo, deleteImportRollInfo, exportSignExcelTemplate, exportImportSignRollExcel, importSignRollExcel} from 'api/operateToolApi'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'SignRollList',
    data() {
        return {
            checkcolname: '',
            testInfo: {label: ''}, // 详情按钮专用模拟row点击
            total: 0,
            eventInfo: {
                isverifylist: '',
                signtype: ''
            },
            searchParams: {
                signName: '',
                signtype: '',
                times: ''
            },
            signTypeOptions: [
                {
                    value: '',
                    label: '全部状态'
                },
                {
                    value: '30',
                    label: '已签到'
                },
                {
                    value: '0',
                    label: '未签到'
                }
            ],
            tableData: [],
            multipleSelection: [],
            importDialog: false, // 导入弹窗
            fileInfo: '',
            fileList: [],
            showRollDetail: false, // 右侧名单详情显示隐藏
            oldInnerid: '',
            newInnerid: '',
            listDetailsInfo: {
                customername: '',
                eticketno: '',
                logourl: '',
                objlist: [],
                signtime: '',
                status: '',
                statustext: ''
            }
        }
    },
    mounted() {
        this.findSignEventBasicInfo()
        this.searchBtn()
    },
    methods: {
        // 获取签到活动的基本信息  判断是否能上传名单及名单详情是否显示票号
        findSignEventBasicInfo() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            getSignEventBasicInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.eventInfo = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        // 关闭右侧名单详情
        closeDetalisInfo() {
            this.showRollDetail = false
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        // 批量删除
        batchDelBtn() {
            this.closeDetalisInfo()
            if (this.multipleSelection.length === 0) {
                this.$message.warning(`请选择要删除的数据！`)
                return
            }
            // console.log(this.multipleSelection)
            var delListIds = []
            for (let i = 0; i < this.multipleSelection.length; i++) {
                delListIds.push(this.multipleSelection[i].innerid)
            }
            delListIds = delListIds.join(',')

            // console.log(delListIds)
            this.$confirm('确认删除当前选中数据！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                var params = {
                    innerid: delListIds
                }
                deleteImportRollInfo({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.$message.success(`删除成功！`)
                        this.searchBtn()
                    },
                    error: data => {
                        console.log('error：', data)
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            }).catch(() => {
                // 取消
            })
        },
        // 导出名单列表
        exportRollBtn() {
            this.closeDetalisInfo()
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                status: this.searchParams.signtype,
                customername: this.searchParams.signName,
                begintime: '',
                endtime: ''
            }
            if (this.searchParams.times !== '') {
                params.begintime = this.searchParams.times[0]
                params.endtime = this.searchParams.times[1]
            }
            exportImportSignRollExcel({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '签到名单列表' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.$message.success('导出成功')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 导入弹窗下载Excel模板
        downTemplaet() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            exportSignExcelTemplate({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '签到名单导入模板' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 移除文件提示
        beforeRemove(file, fileList) {
            // return this.$confirm(`确定移除 ${ file.name }？`, '提示')
            return this.$confirm(`确定移除 ${file.name}？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                // 确定
                this.fileInfo = ''
            })
        },
        // 文件上传限制提示
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
        },
        // 打开导入弹窗
        openImportPop() {
            this.closeDetalisInfo()
            this.importDialog = true
        },
        // 导入弹窗导入EXCEL按钮
        handleImport(file, fileList) {
            this.fileInfo = file.raw
            this.fileList = fileList.slice(-1)
        },
        // 导入弹窗确定导入按钮
        suerImport() {
            // console.log(this.fileInfo)
            if (this.fileInfo === '') {
                this.$message.warning('请选择上传文件！')
            } else {
                this.setLoading(true)
                const fileInfo = this.fileInfo
                let formData = new FormData()
                formData.append('eventinnerid', this.$route.query.eventinnerid)
                formData.append('importexcel', fileInfo)
                importSignRollExcel({
                    data: formData,
                    success: data => {
                        this.setLoading(false)
                        this.handleImportDialogClose()
                        this.$message.success('导入成功')
                        this.setLoading(false)
                        this.findSignEventRollList()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }
        },
        // 获取名单列表
        findSignEventRollList() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                page: 1,
                pageSize: 10
            }
            getSignEventImportList({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.checkcolname = data.data.checkcolname
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        // 关闭导入弹窗
        handleImportDialogClose() {
            // console.log('关闭弹窗')
            // 清空导入
            this.$nextTick(() => {
                this.fileInfo = ''
                this.$refs.upload.clearFiles()
                this.importDialog = false
                // console.log('fileInfo',this.fileInfo)
            })
        },
        // 名单表格每一行点击查询名单详情
        tableRowClick(row, column, cell, event) {
            // console.log(column)
            if (column.label === '操作') {
                // 不做处理
            } else {
                this.oldInnerid = this.newInnerid
                this.newInnerid = row.innerid
                if (this.oldInnerid === this.newInnerid) {
                    this.showRollDetail = !this.showRollDetail
                } else {
                    this.showRollDetail = false
                    this.findSignEventRollDetail(row)
                }
            }
        },
        // 获取名单详情
        findSignEventRollDetail(val) {
            this.setLoading(true)
            var params = {
                innerid: val.innerid
            }
            getSignEventImportRollDetail({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.listDetailsInfo = data.data
                    this.showRollDetail = true
                    // setTimeout(() => {
                    //     this.showRollDetail = true
                    // },50 )
                },
                error: data => {
                    console.log('error：', data)
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        // 名单单行数据删除
        delRollRowList(val) {
            this.$confirm('确认删除该信息？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                var params = {
                    innerid: val.innerid
                }
                deleteImportRollInfo({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.$message.success(`删除成功！`)
                        this.searchBtn()
                    },
                    error: data => {
                        console.log('error：', data)
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            }).catch(() => {
                // 取消
            })
        },
        // 分页及搜索
        handleQuery() {
            this.total = 0
            this.$refs.page.handleSizeChange(1)
        },
        // 搜索按钮
        searchBtn() {
            this.setLoading(true)
            if (this.searchParams.times === null) {
                this.searchParams.times = ''
            }
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                status: this.searchParams.signtype,
                customername: this.searchParams.signName,
                begintime: '',
                endtime: ''
            }
            if (this.searchParams.times !== '') {
                params.begintime = this.searchParams.times[0]
                params.endtime = this.searchParams.times[1]
            }
            getSignEventImportList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.checkcolname = data.data.checkcolname
                    this.total = data.data.pageinfo.rowCount
                    this.closeDetalisInfo()
                },
                error: data => {
                    console.log('error：', data)
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        statusTextClass(val) {
            if (val === '未签到') {
                return 'yellow_text'
            } else if (val === '已签到') {
                return 'green_text'
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss">
.SignRollList {
    font-family:PingFangSC-Regular,PingFang SC;
    .import_tips_box {
        .el-dialog__wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-dialog {
            margin: 0!important;
        }
        .el-dialog__footer {
            padding: 10px 20px;
        }
        .improt-dialog {
            .btnlist {
                display: flex;
                margin-bottom: 20px;
                .el-button {
                    margin-bottom: 0;
                }
                .upload-excel {
                    .el-button {
                        width: 174px;
                        margin-right: 20px;
                    }
                    .el-upload-list__item-name {
                        margin-right: 20px;
                    }
                }
            }
            p {
                font-size: 14px;
                color: #999;
                line-height: 25px;
            }
        }
    }
    .search_handle_box {
        display: flex;
        justify-content: space-between;
        .left_box {
            // min-width: 378px;
            .el-button+.el-button {
                margin-left: 30px;
            }
        }
        .right_box {
            // min-width: 704px;
            display: flex;
            .el-input__icon {
                line-height: 0px;
            }
            &>div {
                margin-right: 30px;
            }
            .sign_time_box {
                .el-date-editor .el-range-separator {
                    line-height: 24px;
                }
                .el-date-editor--daterange.el-input__inner {
                    width: 260px;
                }
            }
        }
    }
    .green_text {
        color: #0ABF53;
    }
    .yellow_text {
        color: #FFA904;
    }
    .table_box {
        margin-top: 30px;
        .el-table th>.cell {
            font-weight: bold!important;
        }
        .el-table__empty-block {
            min-height: 360px;
        }
        .el-table__empty-text {
            box-sizing: border-box;
            line-height: 0px;
            padding-top: 150px;
        }
        .el-table__row {
            cursor: pointer;
        }
        .user_info_box {
            display: flex;
            align-items: center;
            // justify-content: center;
            img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
            span{
                color: #409EFF;
            }
        }
    }
    .right_details_box{
        position: fixed;
        top: 50px;
        right: -398px;
        height: 95.5vh;
        width: 398px;
        z-index: 10;
        box-sizing: border-box;
        box-shadow:-2px 0px 6px 0px rgba(0,0,0,0.1);
        font-family:PingFangSC-Regular,PingFang SC;
        .show_helps{
            width: 12px;
            height: 50px;
            background-size:12px 50px !important;
            position: absolute;
            top: 46%;
            left: -12px;
            cursor: pointer;
            border-radius: 6px 0 0 6px;
        }
        .show_helps:hover{
            background-color: #ccc;
        }
        .show_icon{
            background-image: url('../../../common/images/other/show.png');
        }
        .title_box{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            height: 52px;
            box-shadow: -2px 0px 6px 0px rgba(0,0,0,0.1);
            span{
                font-weight: bold;
                font-size: 15px;
            }
            img {
                width: 10px;
                height: 10px;
                cursor: pointer;
            }
        }
        .details_info_box {
            .box1 {
                display: flex;
                align-items: center;
                padding: 30px 20px 40px 20px;
                img {
                    width: 64px;
                    height: 64px;
                    border-radius: 100%;
                    margin-right: 28px;
                }
                div {
                    p{
                        color:#999999;
                        line-height:20px;
                    }
                    p:nth-of-type(1){
                        color: #333333;
                    }
                    p:nth-of-type(2){
                        margin-top: 8px;
                        margin-bottom: 8px;
                    }
                    p:nth-of-type(3){
                        margin-bottom: 8px;
                    }
                }
            }
            .box2 {
                padding: 0 20px;
                p{
                    display: flex;
                    line-height:20px;
                    color: #333333;
                    margin-top: 20px;
                    span:nth-of-type(1){
                        line-height:20px;
                        color:#999999;
                        width: 120px;
                        min-width: 120px;
                        white-space: nowrap;
                    }
                    span:nth-of-type(2){
                        line-height:20px;
                    }
                }
                p:nth-of-type(1){
                    margin-top: 0px;
                    border-bottom: solid 1px #E5E5E5;
                    padding: 8px 0;
                    font-weight: bold;
                    font-size: 15px;
                }
                .no_info_box {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    padding: 30px 0;
                    span {
                        margin-top: 10px;
                        color:#999999;
                    }
                }
            }
        }
    }
    .show_helps_box{
        right: 0;
        transition: 0.5s all;
    }
    .hide_icon_box{
        right: -398px;
        transition: 0.5s all;
    }
}
</style>